import { render, staticRenderFns } from "./observe.vue?vue&type=template&id=d87f7aba&scoped=true"
import script from "./observe.vue?vue&type=script&lang=js"
export * from "./observe.vue?vue&type=script&lang=js"
import style0 from "./observe.vue?vue&type=style&index=0&id=d87f7aba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87f7aba",
  null
  
)

export default component.exports